import { useCallback, useEffect, useState } from "react";
import { useDataProvider, useNotify, useRedirect } from "react-admin";
import { MenuTreeEdit2 } from "./components/menu-tree-edit-2";
import { MenuTreeMassage } from "./components/menu-tree-massage";
import "./custom.css";

// popup
import "reactjs-popup/dist/index.css";

export const MenuTreeEdit = (props) => {
  const dataProvider = useDataProvider();
  const redirectTo = useRedirect();
  const notify = useNotify();

  // constructor
  const [resp, setResp] = useState({ start_time: "", description: "" });

  // Fetch API
  useEffect(() => {
    dataProvider
      .getOneMenuTree(props.id)
      .then(({ data }) => {
        setResp(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // call PUT API
  const saveMenuTreeCallback = useCallback((params) => {
    const rows = params.rows;
    const startTime = params.startTime;
    const description = params.description;

    // massage rows
    const menuTree = MenuTreeMassage(rows);

    const param = {
      menu_tree: menuTree,
      start_time: startTime,
      description: description,
    };

    dataProvider
      .putMenuTree(props.id, param)
      .then(() => {
        notify("Update Menu tree is Successful", "success");
        redirectTo("/menu-tree");
      })
      .catch((e) => {
        console.log(e);
        notify(e.message.toString(), "warning");
      });
  });

  return resp.menu_tree ? ( //
    <MenuTreeEdit2 //
      {...props}
      mode="edit"
      rows={JSON.parse(JSON.stringify(resp.menu_tree))}
      start_time={resp.start_time}
      description={resp.description}
      saveMenuTreeCallback={saveMenuTreeCallback}
    />
  ) : (
    <></>
  );
};
